// generated from 15_130 samples

import { z } from "zod";

export const performedConversionTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PerformedConversion"),
});
